<ds-form-field [ngClass]="styleClass">
    <label
        ds-label
        [for]="inputId"
        >{{ label | translate }}</label
    >
    <ds-select
        [id]="inputId"
        [labellingConfig]="{ placeholder: placeholder }"
        [showClearAll]="showClear"
        [isMultiselect]="multiSelect"
        [variant]="variant"
        [isLoading]="isLoading"
        [disabled]="isDisabled"
        [readonly]="readOnly"
        [options]="options"
        [(ngModel)]="value"
        [(overlayConfig)]="overlayConfig"
        (valueChange)="selectionChanged.emit($event)"
        [customFilterFunction]="filterFunction"
        [required]="!showOptionalLabel"
        [isFilterable]="isFilterable"
        [title]="tooltipText"
        [showErrors]="isInvalid"></ds-select>
</ds-form-field>
